import type { OrderAutomaticEmailType } from "@daytrip/legacy-enums";

import { GInputType, GObjectType } from "../graphql";

import { AutomaticEmail } from "./AutomaticEmail";

@GObjectType("OrderAutomaticEmail")
@GInputType("OrderAutomaticEmailInput")
export class OrderAutomaticEmail extends AutomaticEmail<OrderAutomaticEmailType> {}
